export default __webpack_public_path__ + "2021 Excited-state vibration-polariton transitions and dynamics in nitroprusside.pdf";